var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"region-selector"},[_c('div',{staticClass:"label"},[_vm._v("Available in")]),_c('selector',{attrs:{"value":_vm.region,"items":_vm.regions},on:{"change":function($event){return _vm.$emit("update:region", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }